<template>
  <Plan
    is-pro
    title="Pro+"
    description="Looking to take your bio links to the next level? Look no further."
    :price="currentPrice"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
    :blocks="blocks"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import Plan from './plan';
import { PROFILE_PRICES, PRO_PLUS } from './plans';

const FEATURES = [
  {
    title: 'All of the Pro features',
  },
  {
    title: 'Get 6 profiles out of the box',
  },
  {
    title: 'Get some help with 4 collaborators',
  },
  {
    title: 'View lifetime analytics for all of your profiles',
  },
  {
    title:
      'Analyze your profile traffic in depth with our reporting tools and filtering',
  },
  {
    title: 'Export your analytics data as a .csv',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    interval: {
      type: String,
      default: 'month',
    },

    profiles: {
      type: Number,
      default: 1,
    },

    blocks: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const currentPrice = computed(() => {
      const profilePrice =
        PROFILE_PRICES[props.interval] *
        Math.max(props.profiles - PRO_PLUS.numberOfProfiles, 0);

      return PRO_PLUS.price[props.interval] + profilePrice;
    });

    return {
      FEATURES,
      currentPrice,
    };
  },
};
</script>

<style lang="scss" scoped></style>
